import { createI18n } from "vue-i18n";
import messages from "src/i18n";

const isDev = process.env.NODE_ENV === "development";

const i18n = createI18n({
  locale: navigator.language.toLowerCase(),
  fallbackLocale: "en-us",
  legacy: true, // Use legacy mode for compatibility with Options API
  messages,
  // Only warn about missing translation keys in dev. In production the
  // warnings clutter the console and the runtime cost (string format +
  // console call per render of a missing key) isn't worth paying — the
  // unit-test guard in tests/unit/migration/vue3-v-model.regression.spec.js
  // catches missing keys at build time.
  missingWarn: isDev,
  fallbackWarn: isDev,
  // Several legitimate i18n strings carry hard-coded inline HTML
  // (`<strong>net {netDays} days</strong>` in terms boilerplate, `<b>`
  // in QuoteImport's hint banner, etc.) so vue-i18n 9's default HTML
  // detection fills the console with XSS recommendations every render.
  // Those messages are bundled at build time from our own i18n/en-us
  // catalog — no user input ever flows into the key *itself*. Suppress
  // the warning since the audit it asks for has been done.
  //
  // For defense in depth, escape any interpolated parameter so any
  // future parameter that DOES come from user input gets HTML-escaped
  // before being interpolated into a v-html-rendered message. Combined
  // with the warning-suppressed message text, that means HTML can only
  // come from our static i18n catalog, never from runtime data.
  //
  // NOTE: because we run in legacy mode (`legacy: true`), vue-i18n's
  // legacy factory reads the *legacy* option names — `warnHtmlInMessage`
  // / `escapeParameterHtml`. The composition-mode names
  // (`warnHtmlMessage` / `escapeParameter`) are silently ignored here.
  warnHtmlInMessage: "off",
  escapeParameterHtml: true,
});

export default ({ app }) => {
  // Set i18n instance on app
  app.use(i18n);
};

// Non-component code (route definitions, classes, store actions, util
// functions) should import { i18n } from this file and call
// `i18n.global.t(...)` / `i18n.global.tc(...)`. The previous shape
// (`export const t = i18n.global.t`) captured a bare function
// reference at module-load time; that happens to work in legacy mode
// because vue-i18n's `t` is internally bound, but it's an
// implementation detail — going through `i18n.global` every call is
// the documented Vue 3 pattern and survives a future composition-mode
// switch.
export { i18n };
